import React, { useState } from 'react';
import { CheckCircle2Icon, Loader2Icon, SendIcon } from 'lucide-react';
import { inquiryTypes, profile } from '../data/profile';
import { PageHeader } from '../components/PageHeader';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const fieldClass = 'w-full bg-parchment px-4 py-3 font-sans text-[15px] text-navy placeholder:text-navy-200 transition-colors duration-150 ease-out focus:bg-white focus:outline-none focus:ring-1 focus:ring-emerald';
const labelClass = 'block font-sans text-xs font-medium uppercase tracking-overline text-navy-400';
export function Inquire() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    name: '',
    organization: '',
    inquiryType: inquiryTypes[0],
    message: ''
  });
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!form.name.trim() || !form.organization.trim() || !form.message.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section className="bg-parchment py-16 lg:py-24" data-id="element-132" data-mp="1ucn1eosxk6n6">
      <div className="mx-auto max-w-dossier px-6 lg:px-10" data-id="element-133" data-mp="1ua0riiikhf1s">
        <PageHeader overline="Inquire" title="For nominating committees and advisory boards" description="Inquiries regarding board service, strategic advisory engagements, or speaking opportunities are reviewed directly and answered within five business days." data-id="element-134" data-mp="291jg34phshwr" />

        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-135" data-mp="2d1jx8x3z777i">
          <div className="lg:col-span-4" data-id="element-136" data-mp="2rzvryy7sg5w1">
            <dl className="space-y-8" data-id="element-137" data-mp="2ryuekn3av7b5">
              <div data-id="element-138" data-mp="2n0snbevq01ol">
                <dt className="font-sans text-[11px] uppercase tracking-overline text-navy-400" data-id="element-139" data-mp="2n09b8esr47ih">
                  Governance focus
                </dt>
                <dd className="mt-2 font-sans text-[17px] leading-relaxed text-navy" data-id="element-140" data-mp="xnfo242gt3uc">
                  Compensation · Human Capital · Audit-adjacent Risk
                </dd>
              </div>
              <div data-id="element-141" data-mp="1icq8b05g9374">
                <dt className="font-sans text-[11px] uppercase tracking-overline text-navy-400" data-id="element-142" data-mp="1mbz4ebnypd5u">
                  Availability
                </dt>
                <dd className="mt-2 font-sans text-[17px] leading-relaxed text-navy" data-id="element-143" data-mp="1r9qv52cvet8g">
                  Public, private, and growth-stage boards
                </dd>
              </div>
              <div data-id="element-144" data-mp="218ghb7bsuzui">
                <dt className="font-sans text-[11px] uppercase tracking-overline text-navy-400" data-id="element-145" data-mp="218zuybuf322q">
                  Based in
                </dt>
                <dd className="mt-2 font-sans text-[17px] leading-relaxed text-navy" data-id="element-146" data-mp="2a2396mcvziyf">
                  {profile.location}
                </dd>
              </div>
              <div data-id="element-147" data-mp="2f04t19i4zmay">
                <dt className="font-sans text-[11px] uppercase tracking-overline text-navy-400" data-id="element-148" data-mp="2jzzgt46m7vrs">
                  References
                </dt>
                <dd className="mt-2 font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-149" data-mp="2p05a0osj9qbz">
                  {profile.contactNote}
                </dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-8" data-id="element-150" data-mp="8bulxklei8go">
            <div className="bg-parchment-light p-8 lg:p-10" data-id="element-151" data-mp="8f0a8xm7h6bc">
              {status === 'success' ? <div className="flex flex-col items-start gap-4 py-8" data-id="element-152" data-mp="3ujvksm69r8cw">
                  <CheckCircle2Icon className="h-9 w-9 text-emerald" aria-hidden="true" data-id="element-153" data-mp="3ulots84cu4o2" />
                  <h2 className="font-display text-3xl text-navy" data-id="element-154" data-mp="w1ozk4djo11z">Inquiry received</h2>
                  <p className="max-w-md font-sans text-[15px] leading-relaxed text-navy-600" data-id="element-155" data-mp="r4genw10hix1">
                    Thank you, {form.name.split(' ')[0]}. Your {form.inquiryType.toLowerCase()}{' '}
                    inquiry has been logged and will receive a direct response shortly.
                  </p>
                  <button type="button" onClick={() => {
                setForm({
                  name: '',
                  organization: '',
                  inquiryType: inquiryTypes[0],
                  message: ''
                });
                setStatus('idle');
              }} className="mt-2 font-sans text-sm font-medium text-emerald underline decoration-emerald-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-emerald-700" data-id="element-156" data-mp="1ethonnpht24f">
                    Submit another inquiry
                  </button>
                </div> : <form onSubmit={handleSubmit} noValidate className="space-y-7" data-id="element-157" data-mp="1dbskr04yi0rw">
                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-158" data-mp="1i9u31iuk5w2b">
                    <div data-id="element-159" data-mp="1ibexz9ksbh0p">
                      <label className={labelClass} htmlFor="name" data-id="element-160" data-mp="13l7rls81xogd">
                        Full name
                      </label>
                      <input id="name" name="name" type="text" autoComplete="name" value={form.name} onChange={e => setForm({
                    ...form,
                    name: e.target.value
                  })} placeholder="Jane Whitfield" className={`${fieldClass} mt-2`} data-id="element-161" data-mp="18ig6njxwlcde" />
                    </div>
                    <div data-id="element-162" data-mp="3vgsazh00gtmb">
                      <label className={labelClass} htmlFor="organization" data-id="element-163" data-mp="3vez4q2tb8beu">
                        Organization / Board committee
                      </label>
                      <input id="organization" name="organization" type="text" value={form.organization} onChange={e => setForm({
                    ...form,
                    organization: e.target.value
                  })} placeholder="Nominating & Governance Committee" className={`${fieldClass} mt-2`} data-id="element-164" data-mp="32rczyr8cj0qe" />
                    </div>
                  </div>

                  <fieldset data-id="element-165" data-mp="n0qu29qqu5ay">
                    <legend className={labelClass} data-id="element-166" data-mp="mzffdevrfd52">Inquiry type</legend>
                    <div className="mt-3 flex flex-wrap gap-2" data-id="element-167" data-mp="3fv7h34zoi63y">
                      {inquiryTypes.map(type => {
                    const active = form.inquiryType === type;
                    return <button key={type} type="button" aria-pressed={active} onClick={() => setForm({
                      ...form,
                      inquiryType: type
                    })} className={`px-4 py-2.5 font-sans text-sm transition-colors duration-150 ease-out ${active ? 'bg-emerald text-white' : 'bg-parchment text-navy-600 hover:bg-parchment-deep'}`} data-id="element-168" data-mp="3psvfq60enxre">
                            {type}
                          </button>;
                  })}
                    </div>
                  </fieldset>

                  <div data-id="element-169" data-mp="2avshyi56yzbm">
                    <label className={labelClass} htmlFor="message" data-id="element-170" data-mp="2awaj9t6po3qe">
                      Message
                    </label>
                    <textarea id="message" name="message" rows={5} value={form.message} onChange={e => setForm({
                  ...form,
                  message: e.target.value
                })} placeholder="Scope of the role, committee needs, and timeline." className={`${fieldClass} mt-2 resize-none`} data-id="element-171" data-mp="25xh6k2z90gra" />
                  </div>

                  {status === 'error' && <p role="alert" className="font-sans text-sm text-red-700" data-id="element-172" data-mp="1i7mwtua878b9">
                      Please complete your name, organization, and message before submitting.
                    </p>}

                  <button type="submit" disabled={status === 'submitting'} className="inline-flex items-center justify-center gap-2 bg-navy px-7 py-4 font-sans text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-emerald disabled:opacity-70" data-id="element-173" data-mp="198jckmzbomv6">
                    {status === 'submitting' ? <>
                        <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-174" data-mp="2o26u5wsewq1m" />
                        Sending
                      </> : <>
                        <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="2e526fsix4mip" />
                        Submit inquiry
                      </>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}